import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import useAlarmChecker from './hooks/useAlarmChecker';
import HomePage from './pages/HomePage';
import RadioPlayer from './pages/RadioPlayer';
import AudioPublicPage from './pages/AudioPublicPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import DeleteAccountPage from './pages/DeleteAccountPage';
import ChildSafetyPage from './pages/ChildSafetyPage';
import GrabarPage from './pages/GrabarPage';
import CombosPage from './pages/CombosPage';
import ComboPublicPage from './pages/ComboPublicPage';
import PerfilPage from './pages/PerfilPage';
import AjustesPage from './pages/AjustesPage';
import CompartirPage from './pages/CompartirPage';
import OnboardingPage from './pages/OnboardingPage';
import HiloPage from './pages/HiloPage';
import HistorialPage from './pages/HistorialPage';
import UserProfilePage from './pages/UserProfilePage';
import './App.css';

// Componente que usa el hook de alarmas
const AlarmChecker = () => {
  useAlarmChecker();
  return null;
};

// Main Router Component
const AppRouter = () => {
  const location = useLocation();
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [checkingOnboarding, setCheckingOnboarding] = useState(true);

  useEffect(() => {
    // Skip onboarding for shared links (combo, audio, usuario, hilo)
    const sharedPaths = ['/combo/', '/audio/', '/usuario/', '/hilo/'];
    const isSharedLink = sharedPaths.some(path => location.pathname.startsWith(path));
    
    if (isSharedLink) {
      // Mark onboarding as done and skip
      localStorage.setItem('audioyou_onboarding_done', 'true');
      setShowOnboarding(false);
      setCheckingOnboarding(false);
      return;
    }
    
    // Verificar si ya hizo onboarding
    const done = localStorage.getItem('audioyou_onboarding_done');
    if (!done) {
      setShowOnboarding(true);
    }
    setCheckingOnboarding(false);
  }, [location.pathname]);

  // Mostrar loading mientras verifica
  if (checkingOnboarding) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center">
        <div className="animate-spin w-10 h-10 border-4 border-purple-500 border-t-transparent rounded-full" />
      </div>
    );
  }

  // Mostrar onboarding si no lo ha hecho
  if (showOnboarding) {
    return <OnboardingPage onComplete={() => setShowOnboarding(false)} />;
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/grabar" element={<GrabarPage />} />
      <Route path="/compartir" element={<CompartirPage />} />
      <Route path="/combos" element={<CombosPage />} />
      <Route path="/combo/:comboId" element={<ComboPublicPage />} />
      <Route path="/c/:comboId" element={<ComboPublicPage />} />
      <Route path="/perfil" element={<PerfilPage />} />
      <Route path="/perfil/ajustes" element={<AjustesPage />} />
      <Route path="/historial" element={<HistorialPage />} />
      <Route path="/radio" element={<RadioPlayer />} />
      <Route path="/audio/:audioId" element={<AudioPublicPage />} />
      <Route path="/hilo/:threadId" element={<HiloPage />} />
      <Route path="/usuario/:userId" element={<UserProfilePage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/eliminar-cuenta" element={<DeleteAccountPage />} />
      <Route path="/seguridad-infantil" element={<ChildSafetyPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App">
          <AlarmChecker />
          <AppRouter />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
